import axios from "axios";
const GlobalConfig = {
  install(Vue) {
    Vue.mixin({
      methods: {
        /*
          Calculate the Age based on date passed (YYYY-MM-DD) to the function
        */
        calculateAge(year, month, day) {
          var today = new Date();
          var birthDate = new Date(year, month, day);
          var age = today.getFullYear() - birthDate.getFullYear();
          var m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          return age;
        },
        getExternalContactPreferences(ssoid) {
          return new Promise((resolve) => {
            // console.log('Attempting to get contact prefernces from external source')
            switch (this.configValues.contactPreferencesParentSystem) {
              case "XCM":
                resolve(this.crmXCMGetPreferences());
                break;
              case "Dummy":
                resolve(this.dummyCRMGetPreferences());
                break;
              default:
                resolve(null);
                break;
            }
          });
        },
        dummyCRMGetPreferences() {
          return new Promise((resolve) => {
            // console.log('triggered dummy crm push')
            var dummyUserData = {
              clubEmail: "Y",
              clubPhone: "Y",
              clubDirect: "Y",
              clubSMS: "Y",
            };
            resolve(dummyUserData);
          });
        },
        dummyCRMPushFunction() {
          return new Promise((resolve) => {
            // console.log('triggered dummy crm push')
            resolve();
          });
        },
        crmXCMPushFunction(username) {
          var crmXCMPushURL =
            this.configValuesxcmConfig.pushDataEndpoint + username;
          // console.log('XCM push url', crmXCMPushURL)
          return axios({
            method: "get",
            url: crmXCMPushURL,
          });
        },
        crmXCMGetPreferences(ssoid) {
          return new Promise((resolve, reject) => {
            var crmURL =
              this.configValuesxcmConfig.contactPreferencesEndpoint + ssoid;
            // console.log('XCM push url', crmURL)
            axios({
              method: "get",
              url: crmURL,
            }).then(function (response) {
              // console.log('XCM response', response)
              if (response.data.success === true) {
                // console.log('XCM prefs found, setting local values to XCM values')
                var xcmData = response.data.data.Preferences;
                var userData = {}; // a dummy object to place our normalised data back into
                userData.clubEmail =
                  xcmData["Email"]["Club Communication"] == "Y" ? true : false;
                userData.clubDirect =
                  xcmData["Direct Mail"]["Club Communication"] == "Y"
                    ? true
                    : false;
                userData.clubPhone =
                  xcmData["Phone"]["Club Communication"] == "Y" ? true : false;
                userData.clubSMS =
                  xcmData["SMS"]["Club Communication"] == "Y" ? true : false;
                userData.partnerEmail =
                  xcmData["Email"]["Partner Communication"] == "Y"
                    ? true
                    : false;
                userData.partnerDirect =
                  xcmData["Direct Mail"]["Partner Communication"] == "Y"
                    ? true
                    : false;
                userData.partnerPhone =
                  xcmData["Phone"]["Partner Communication"] == "Y"
                    ? true
                    : false;
                userData.partnerSMS =
                  xcmData["SMS"]["Partner Communication"] == "Y" ? true : false;
                userData.clubAds =
                  xcmData["Digital Ads"]["Club Communication"] == "Y"
                    ? true
                    : false;
                userData.foundationEmail =
                  xcmData["Email"]["AV Foundation"] == "Y" ? true : false;
                userData.partnerAds =
                  xcmData["Digital Ads"]["Partner Communication"] == "Y"
                    ? true
                    : false;
                resolve(userData);
              } else {
                reject(new Error("XCM failed to respond"));
              }
            });
          });
        },
        dataPush(username) {
          return new Promise((resolve) => {
            // console.log('Establishing enpoints to push data')
            // build list of data push functions that we need to trigger
            var dataPushFunctions = [];

            if (this.configValues.dummyCRMEnabled === true) {
              dataPushFunctions.push(this.dummyCRMPushFunction);
            }

            if (this.configValues.xcmCRMIntegrationEnabled === true) {
              dataPushFunctions.push(this.crmXCMPushFunction);
            }

            Promise.all(dataPushFunctions).then(function (results) {
              // console.log('CRM update results', results[0])
              resolve();
            });
          });
        },
      },
      data: function () {
        return {
          get configStrings() {
            return {
              clubName: "Leyton Orient",
              productName: "OneOrient",
              clubIdentifierName: "Client Reference Number",
              clubStreamingPlatformName: "Orient TV",
              clubWebsiteLink: "https://www.leytonorient.com/",
              clubPrivacyPolicyLink:
                "https://www.leytonorient.com/privacy-policy",
              clubPartnersLink:
                "https://www.leytonorient.com/commercial-and-club-partners/our-partners/",
              clubSSOHelpLink: "https://www.leytonorient.com/",
              clubSSOVerificationEmailAddress: "noreply@leytonorient.net",
            };
          },

          get configValues() {
            return {
              clubRootDomain: "leytonorient.com",
              accountConsentRequired: false, // true or false
              accountConsentAge: 13, // numeric value
              accountDoBUpdatesAllowed: true, // true or false
              accountRequestAddressOnFirstLogin: true, // true or false
              accountProfilePicturesAllowed: false, // true or false
              profilePictures: {
                s3Bucket: "sso-images.leytonorient.com",
              },
              accountGenderRequested: true, // true or false
              accountGenderList: [
                "",
                "Male",
                "Female",
                "Other",
                "Prefer not to say",
              ],
              contactPreferencesParentSystem: null, // String (Dummy, XCM, SportsAlliance etc.). null if not relevant
              // Seatgeek integration options
              seatGeekAccountLinkingEnabled: false, // true or false
              seatGeekConfig: {
                liveOrigin: "https://tickets.urbanzoofc.com",
                iframeURL: "https://tickets.urbanzoofc.com/test/",
              },
              // Dummy CRM integration options
              dummyCRMEnabled: true,
              // XCM CRM integration options
              xcmCRMIntegrationEnabled: false,
              xcmConfig: {
                pushDataEndpoint: "",
                contactPreferencesEndpoint:
                  "https://domain.com/user/preferences/",
              },
              communitySchemeMarketingEnabled: false,
              communityScheme: {
                name: "Leyton Orient Community",
              },
            };
          },

          /*
          An array of domains that the site trusts in order to perform redirects
          */
          get configTrustedDomains() {
            return [
              "stagingozonelivepayments.streamamg.com",
              "ozonelivepayments.streamamg.com",
              "leytonorient.com",
              "leytonorientfcservices.co.uk",
            ];
          },

          /*
          An array of the items that will be populated in the Official Websites list of the portal
          */
          get configOfficialWebsites() {
            return [
              {
                title: "Official website",
                URL: "https://www.leytonorient.com",
                target: "_blank",
              },
              {
                title: "Online Store",
                URL: "https://shop.leytonorient.com",
                target: "",
              },
              {
                title: 'Tickets',
                URL: 'https://www.eticketing.co.uk/leytonorient/',
                target: '_blank'
              }
            ];
          },
        };
      },
    });
  },
};
export default GlobalConfig;
